import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { FiArchive, FiCheckCircle, FiFileText, FiSend } from "react-icons/fi";
import styles from "./Dashboard.module.scss";
import { formatFullTreatmentValue, formatTreatmentValue, getConsentDisplayStatus, getNextAppointment, getTreatmentValue } from "./dashboardPresentation";

export function TreatmentValuePill({ record }: { record: Record<string, any> }) {
  const value = getTreatmentValue(record);
  const booked = Boolean(getNextAppointment(record));
  const fullValue = formatFullTreatmentValue(value);
  return (
    <Tooltip title={fullValue} describeChild>
      <span tabIndex={0} aria-label={fullValue} className={`${styles.dataPill} ${booked ? styles.bookedPill : styles.unbookedPill}`}>
        {formatTreatmentValue(value)}
      </span>
    </Tooltip>
  );
}

export function NextAppointmentPill({ record }: { record: Record<string, any> }) {
  const appointment = getNextAppointment(record);
  return (
    <span className={`${styles.dataPill} ${appointment ? styles.bookedPill : styles.unbookedPill}`}>
      {appointment ? new Intl.DateTimeFormat("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }).format(appointment) : "Unbooked"}
    </span>
  );
}

export function ConsentStatusPill({ record }: { record: Record<string, any> }) {
  const status = getConsentDisplayStatus(record);
  const Icon = status === "Archived" ? FiArchive : status === "Completed" ? FiCheckCircle : status === "Draft" ? FiFileText : FiSend;
  const color = status === "Archived" ? styles.statusArchived : status === "Completed" ? styles.statusCompleted : status === "Draft" ? styles.statusDraft : styles.statusSent;
  return <span className={`${styles.consentPill} ${color}`}><Icon aria-hidden="true" />{status}</span>;
}
